import type { Locale } from "@ct-react/locale";
import FrenchMessages from "./fr-CH.json";
import EnglishMessages from "./en-GB.json";
import GermanMessages from "./de-CH.json";

export const getIntlMessages = (locale: Locale) => {
  switch (locale.basename) {
    case "fr": return FrenchMessages;
    case "en": return EnglishMessages;
    case "de": return GermanMessages;
    default: throw new Error(`missing translations for locale ${locale.code}`);
  }
};
